import { computed } from 'vue';
import { usePermissions, useBooleanSetting } from '@/composables';
import { useCurrentUser } from '@/features/Auth';
import { Feature } from '@/constants/features';
import { Setting } from '@/constants/settings';

/**
 * Composable to check if subtasks feature is enabled for the current user.
 *
 * Checks all the necessary conditions:
 * - User is NOT a CUPO user
 * - User has SUBTASKS feature permission
 * - USE_SUBTASKS setting is enabled
 *
 * @returns boolean computed property indicating if subtasks are enabled
 */
export function useSubtasksPermissions() {
	const { isCUPOUser } = useCurrentUser();
	const { userHas } = usePermissions();
	const [useSubtasksSetting] = useBooleanSetting(Setting.USE_SUBTASKS);

	const isSubtasksEnabled = computed(
		() =>
			!isCUPOUser.value &&
			userHas(Feature.SUBTASKS) &&
			useSubtasksSetting.value
	);

	return {
		isSubtasksEnabled,
	};
}
